/**
 * Mixin to handle item availability logic for showings and delivery locations.
 *
 * @mixin
 * @requires order - Must be provided via inject
 * @requires deliveryLocations - Must be provided via configuration
 *
 * Key features:
 * - Checks item availability based on showing badges
 * - Handles theater seat delivery locations
 * - Validates category requirements for showings
 */
export default {
  configuration: ['deliveryLocations'],
  inject: ['order'],
  methods: {
    /**
     * Determines if an item is available for purchase based on multiple criteria
     *
     * @param {Object} item - The item to check availability for
     * @param {boolean} item.active - Whether the item is active
     * @param {boolean} item.availableOnline - Whether the item can be purchased online
     * @param {Object} item.category - The item's category with showing badge requirements
     * @returns {boolean} True if the item is available, false otherwise
     */
    isItemAvailable (item) {
      if (!this.order) return true

      if (!item.isActive) return false

      if (!this.$consumer) return true

      if (!item.availableOnline) return false

      if (!_.isNil(item.category) && !_.includes(this.order.availableOnlineCategories, item.category)) return false

      return true
    }
  }
}
